import api from '../../axios'

const state = {
  items: [],
  current: '',
  loading: false,
  error: null,
}

const mutations = {
  SET_ITEMS(state, payload) {
    state.items = Array.isArray(payload) ? payload : []
  },
  SET_CURRENT(state, code) {
    state.current = typeof code === 'string' ? code : ''
  },
  SET_LOADING(state, flag) {
    state.loading = !!flag
  },
  SET_ERROR(state, err) {
    state.error = err || null
  },
}

const actions = {
  async initCurrency({ commit, dispatch }) {
    try {
      const saved = localStorage.getItem('currency')
      if (saved) {
        commit('SET_CURRENT', saved)
      }
    } catch (e) {
      // ignore
    }
    await dispatch('fetchCurrencies')
  },

  async fetchCurrencies({ commit, state }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const res = await api.get('/currencies')
      // API shape: { status: 'OK', payload: [...] }
      const list = Array.isArray(res.data && res.data.payload) ? res.data.payload : []
      commit('SET_ITEMS', list)

      const isKnown = list.some(i => i.code === state.current)
      if (!isKnown && list.length) {
        // No currency or one missing from API: prefer EUR, otherwise the first currency
        const preferred = list.find(i => i.code === 'EUR')
        const pick = preferred || list[0]
        const code = (pick && pick.code) || ''
        if (code) {
          commit('SET_CURRENT', code)
          try { localStorage.setItem('currency', code) } catch (e) { void e }
        }
      }
    } catch (e) {
      commit('SET_ERROR', (e && e.message) || 'Failed to load currencies')
    } finally {
      commit('SET_LOADING', false)
    }
  },

  setCurrency({ commit }, code) {
    commit('SET_CURRENT', code)
    try { localStorage.setItem('currency', code) } catch (e) { void e }
  },
}

const getters = {
  currencies: (s) => s.items,
  // Prebuilt options for UI dropdowns
  currencyOptions: (s) => (Array.isArray(s.items) ? s.items : []).map(item => {
    const code = item.code || ''
    const symbol = item.symbol || ''
    const showSymbol = symbol && symbol !== code
    const parts = [code, showSymbol ? `(${symbol})` : ''].filter(Boolean)
    return { value: code, label: parts.join(' ') }
  }),
  currentCurrency: (s) => s.current,
  isCurrenciesLoading: (s) => s.loading,
  currenciesError: (s) => s.error,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
